module.exports = __webpack_public_path__ + "img/tooltip-close-icon.1636f72c.svg";